'use strict';
import {createActions} from 'client/framework';

const normalActions = [
  'INITIALIZE_QUESTION_LIST'
];

export default createActions(null, normalActions);
